import React from 'react'
import Forms from '../components/Forms'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

export default function Banner() {

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};


  return (
    <>
      <section className="banner">
    <div className="container-fluid">
        <div className="row">
            <div className="col-md-12 p-0">
                <div className="sub-banner">
                    {/* <div id="carouselFade" className="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-pause="false" data-bs-interval="2000" >
                        <div className="carousel-inner">
                          <div className="carousel-item active">
                            <img src="assets/img/banner2.jpg" className="d-block w-100" alt="Dubai" />
                            <div className="carousel-caption">
                                <h1>Dubai</h1>
                                <p>Embark on an adventure into the breathtaking realm of the Himalayan wonderland.</p>
                              </div>
                          </div>

                          <div className="carousel-item">
                            <img src="assets/img/banner1.jpg" className="d-block w-100" alt="Leh Ladakh" />
                            <div className="carousel-caption">
                                <h1>Leh Ladakh</h1>
                                <p>Embark on an adventure into the breathtaking realm of the Himalayan wonderland.</p>
                              </div>
                          </div>
                          
                          <div className="carousel-item">
                            <img src="assets/img/banner3.jpg" className="d-block w-100" alt="Maldives" />
                            <div className="carousel-caption">
                                <h1>Maldives</h1>
                                <p>Embark on an adventure into the breathtaking realm of the Himalayan wonderland.</p>
                              </div>
                          </div>  
                        </div>
                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselFade" data-bs-slide="prev">
                          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#carouselFade" data-bs-slide="next">
                          <span className="carousel-control-next-icon" aria-hidden="true"></span>
                          <span className="visually-hidden">Next</span>
                        </button>
                    </div> */}

                    <Carousel fade responsive={responsive}infinite={true}autoPlay={true}autoPlaySpeed={5000}swipeable={true} pauseOnHover={false} draggable={false} ssr={true}removeArrowOnDeviceType={["tablet", "mobile"]}>
                       <div className="carousel-item active">
                            <img src="assets/img/banner2.jpg" className="d-block w-100" alt="Dubai" />
                            <div className="carousel-caption">
                                <h1>Dubai</h1>
                                <p>Dubai—your gateway to luxury living, desert magic, and futuristic wonders</p>
                              </div>
                          </div>
                          
                          <div className="carousel-item active">
                            <img src="assets/img/andaman3-inner-banner.jpg" className="d-block w-100" alt="Andaman" />
                            <div className="carousel-caption">
                                <h1>Andaman Islands</h1>
                                <p>Discover the Andamans—coral reefs, white-sand shores, and India's most serene island escape.</p>
                              </div>
                          </div>
                          <div className="carousel-item active">
                            <img src="assets/img/banner1.jpg" className="d-block w-100" alt="Leh Ladakh" />
                            <div className="carousel-caption">
                                <h1>Ladakh</h1>
                                <p>Breathtaking landscapes, ancient monasteries, and journeys that transform you.</p>
                              </div>
                          </div>
                          <div className="carousel-item active ">
                            <img src="assets/img/banner3.jpg" className="d-block w-100" alt="Maldives" />
                            <div className="carousel-caption">
                                <h1>Maldives</h1>
                                <p>Discover the Maldives—turquoise lagoons, overwater villas, and dreamlike island escapes.</p>
                              </div>
                          </div>  
                    </Carousel>

                   
                    <div className="queryForm">
                    
                        <h2>Any Query? <strong>Call Now</strong></h2>
                    <Forms submitBtnName="Submit" formsource="Banner"/>
                </div>
                </div>
                
            </div>
        </div>
    </div>
</section>
    </>
  )
}
